import React, { useState, useRef } from "react";
import HTMLEditorModal from "./HTMLEditorModal";

// Notes shown as formatted text with an Edit button (2026-10-23), the way
// mobile does it. The Place and Event edit dialogs used to start a full
// TinyMCE editor every time they opened — and every editor start counts as
// one load against the TinyMCE plan — even when the notes weren't touched.
// Now the editor only starts when Edit is pressed, in the same editor window
// as Edit My Notes / Edit Itinerary, and hands the notes back on OK.
//
// The preview is an isolated frame: saved notes begin with their own <style>
// block, which must not restyle the dialog around them. It grows to the
// notes' full height, so only the dialog scrolls (no scrollbar inside a
// scrollbar). No scripts run in it.
const NotesPreview = ({ html, title, onChange }) => {
  const [editing, setEditing] = useState(false);
  const [height, setHeight] = useState(60);
  const frame = useRef(null);
  const hasNotes = String(html || "").replace(/<style[\s\S]*?<\/style>/gi, "").replace(/<[^>]*>/g, "").trim() !== ""
    || /<img|<iframe|<video/i.test(String(html || ""));

  const fit = () => {
    const doc = frame.current && frame.current.contentDocument;
    if (!doc || !doc.body) return;
    setHeight(Math.max(40, doc.documentElement.scrollHeight));
    // Pictures change the height as they arrive.
    doc.querySelectorAll("img").forEach((img) => { if (!img.complete) img.addEventListener("load", fit, { once: true }); });
  };

  return (
    <div>
      {hasNotes ? (
        <iframe
          ref={frame}
          title={title || "Notes"}
          srcDoc={`<html><head><meta charset="utf-8"><style>html,body{overflow:hidden}body{font-family:-apple-system,BlinkMacSystemFont,sans-serif;font-size:14px;margin:8px;color:#222}img{max-width:100%;height:auto}</style></head><body>${html}</body></html>`}
          sandbox="allow-same-origin"
          scrolling="no"
          onLoad={fit}
          style={{ width: "100%", height, border: "1px solid #E4E4E7", borderRadius: 8, background: "#fff", display: "block" }}
        />
      ) : (
        <div style={{ color: "#71717A", fontSize: 14, padding: "6px 0" }}>No notes yet.</div>
      )}
      <button type="button" className="btn btn-outline-primary btn-sm" style={{ marginTop: 8 }} onClick={() => setEditing(true)}>
        {hasNotes ? "Edit notes" : "Add notes"}
      </button>
      <HTMLEditorModal
        show={editing}
        onHide={() => setEditing(false)}
        html={html}
        callback={(newHtml) => { onChange(newHtml); }}
        callback_rt={null}
        title={title || "Notes"}
      />
    </div>
  );
};

export default NotesPreview;
